// Centralised data-testid registry
export const TID = {
    // Hero
    heroTag: "hero-tag",
    heroHeading: "hero-heading",
    heroRotatingWord: "hero-rotating-word",
    heroSubheadline: "hero-subheadline",
    heroCta: "hero-cta-button",

    // Selected Work
    selectedWorkSection: "selected-work-section",
    selectedWorkLabel: "selected-work-label",
    selectedWorkCard: (i) => `selected-work-card-${i}`,
    selectedWorkLive: (i) => `selected-work-live-${i}`,

    // Story scroll
    storyPhrase: (i) => `story-phrase-${i}`,

    // Audience
    audienceCenter: "audience-center-orb",
    audienceKeyword: (slug) => `audience-keyword-${slug}`,

    // Services
    servicesIntroTitle: "services-intro-title",
    serviceCard: (i) => `service-card-${i}`,

    // Interactive Questions
    questionPanel: (i) => `question-panel-${i}`,

    // Built For
    builtForMorph: "built-for-morph-word",
    builtForTagline: "built-for-tagline",

    // Before / After
    beforeAfterCard: (i) => `before-after-card-${i}`,
    beforeAfterDivider: (i) => `before-after-divider-${i}`,

    // Stories In Motion
    storiesHeading: "stories-heading",
    stackingCard: (i) => `stacking-card-${i}`,
    stackingViewCase: (i) => `stacking-view-case-${i}`,

    // Free preview
    freePreviewSection: "free-preview-section",

    // Process
    processStage: (slug) => `process-stage-${slug}`,

    // Why us
    whyUsBox: (i) => `why-us-box-${i}`,

    // About
    aboutHeading: "about-heading",
    aboutParagraph: "about-paragraph",

    // CTA
    ctaHeading: "cta-heading",
    ctaButton: "cta-button",

    // Contact form
    contactSection: "contact-section",
    contactStep: (i) => `contact-step-${i}`,
    contactInput: (i) => `contact-input-${i}`,
    contactNext: "contact-next-button",
    contactBack: "contact-back-button",
    contactSubmit: "contact-submit-button",
    contactSuccess: "contact-success-message",
    calendlyEmbed: "calendly-embed",

    // Footer
    footerLinkLinkedIn: "footer-link-linkedin",
    footerLinkEmail: "footer-link-email",
    footerLinkCreator: "footer-link-creator",
};
